import { UPDATE_CURVES } from '../constants'
import { setGlobalAlert } from '.'

export default (abortController = new AbortController()) => async dispatch => {
    const load = async (calculated = false) => {
        const response = await fetch(`/services/plugin-liverig/${calculated ? 'calculated-' : ''}curves/`, {
            signal: abortController.signal
        })

        if (!response.ok) throw new Error(`Could not load ${calculated ? 'calculated' : 'standard'} curves`)

        return await response.json()
    }

    try {
        const curves = await load()
        const calculatedCurves = await load(true)

        dispatch({
            type: UPDATE_CURVES,
            curves: {
                ...curves,
                ...Object.keys(calculatedCurves).reduce(
                    (obj, ch) => ({ ...obj, [ch]: { ...calculatedCurves[ch], calculated: true } }),
                    {}
                )
            }
        })
    } catch (err) {
        if (err.name !== 'AbortError') {
            dispatch(setGlobalAlert('Error loading curves', false))
            console.error('Error loading curves:', err)
        }
    }
}
